/* eslint-disable no-param-reassign,no-empty */

const cookiesMap = {};

document.cookie.split(';').forEach((item) => {
  item = item.trim();
  const [name, value] = item.split('=');
  cookiesMap[name] = value;
  try {
    // 尝试解析 json cookie
    cookiesMap[name] = JSON.parse(value);
  } catch (error) {}
});

export default {
  get(key) {
    return cookiesMap[key];
  },
  set(key, value, exDays) {
    cookiesMap[key] = value;
    const d = new Date();
    d.setTime(d.getTime() + exDays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toGMTString()}`;
    document.cookie = `${key}=${value};${expires};path=/`;
  },
  del(key) {
    delete cookiesMap[key];
    this.set(key, '', -1);
  },
};
